import type { Reply } from './types';

interface Props {
  replies: Reply[];
}

export function ReplyThread({ replies }: Props) {
  return (
    <div>
      <p className='text-[10px] font-bold tracking-[0.12em] uppercase mb-3' style={{ color: 'var(--muted-foreground)' }}>
        Replies
      </p>
      <div className='space-y-3'>
        {replies.length === 0 && (
          <p className='text-sm text-muted-foreground'>No replies yet.</p>
        )}
        {replies.map((reply) => {
          const isAgent = reply.senderType === 'AGENT';
          return (
            <div
              key={reply.id}
              className='rounded-lg p-4 text-sm'
              style={
                isAgent
                  ? {
                      background: 'oklch(0.72 0.14 220 / 0.07)',
                      border: '1px solid oklch(0.72 0.14 220 / 0.2)',
                    }
                  : {
                      background: 'var(--card)',
                      border: '1px solid var(--border)',
                    }
              }
            >
              <div className='flex items-center justify-between mb-2'>
                <div className='flex items-center gap-2'>
                  <span className='font-semibold text-sm'>
                    {reply.author?.name ?? reply.author?.email ?? (isAgent ? 'Agent' : 'Customer')}
                  </span>
                  <span
                    className='inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-bold tracking-wide uppercase'
                    style={
                      isAgent
                        ? { background: 'oklch(0.72 0.14 220 / 0.15)', color: 'oklch(0.72 0.14 220)' }
                        : { background: 'var(--muted)', color: 'var(--muted-foreground)' }
                    }
                  >
                    {isAgent ? 'Agent' : 'Customer'}
                  </span>
                </div>
                <span className='text-xs font-mono-data' style={{ color: 'var(--muted-foreground)' }}>
                  {new Date(reply.createdAt).toLocaleString()}
                </span>
              </div>
              <p className='whitespace-pre-wrap leading-relaxed'>{reply.body}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
